export const TREND_TOOLTIP_ACTION_TYPES = {
    SET_TOOLTIP_X_POS: 'trend_tooltip/SET_TOOLTIP_X_POS',

    CLEAR_TOOLTIP_X_POS: 'trend_tooltip/CLEAR_TOOLTIP_X_POS',
};